import { userConstants } from "./constants/userConstants";

const userRoleRequest = () => ({
  type: userConstants.roleUserRequest,
});

const userCreateRequest = (data:any) => ({
  type: userConstants.userCreateRequest,
  payload: data,
});

const userCreateReset = () => ({
  type: userConstants.userCreateReset,
});

const userListRequest = (data:any) => ({
  type: userConstants.userListRequest,
  payload : data
});

const userUpdateRequest = (data:any) => ({
  type: userConstants.userUpdateRequest,
  payload: data,
});

const userViewRequest = (data:any) => ({  
  type: userConstants.userViewRequest,
  payload: data,
});


const getProfileRequest = (data:any) => {
    return {
        type: userConstants.getProfileRequest,
        payload: data
    }
}

const updateProfileRequest = (data:any) => {
    return {
        type: userConstants.updateProfileRequest,
        payload: data
    }
}

const uploadProfileImageRequest = (data:any) => {
    return {
        type: userConstants.uploadProfileImageRequest,
        payload: data
    }
}

const getTermsByTypeRequest = (type: string) => ({
  type: userConstants.getTermsByTypeRequest,
  payload: type,
});

const getInstructorHistoryRequest = (data: any) => ({
  type: userConstants.getInstructorHistoryRequest,
  payload: data,
});

const getInstructorHistoryReset = () => ({
  type: userConstants.getInstructorHistoryReset,
});

const sendInvitationRequest = (data: any) => ({
  type: userConstants.sendInvitationRequest,
  payload: data,
});

export const userActions = {
  userRoleRequest,
  userCreateRequest,
  userCreateReset,
  userListRequest,
  getProfileRequest,
  userViewRequest,
  updateProfileRequest,
  uploadProfileImageRequest,
  userUpdateRequest,
  getTermsByTypeRequest,
  getInstructorHistoryRequest,
  getInstructorHistoryReset,
  sendInvitationRequest,
};